import React, { useContext } from 'react';
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import { Navbar, NavbarDivider, NavbarSpacer, NavbarItem } from './catalyst/navbar'
import { Dropdown, DropdownButton, DropdownMenu, DropdownItem, DropdownLabel, DropdownDivider } from './catalyst/dropdown'
import { Avatar } from './catalyst/avatar'
import { UserIcon, Cog8ToothIcon, ShieldCheckIcon, LightBulbIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/react/20/solid';
import logo from "../assets/logo.png"
import logo_live from "../assets/logo-LIVE.png"
import logo_test from "../assets/logo-TEST.png"
import logo_bao from "../assets/logo-BAO.png"
import SearchBarNav from './searchbars/SearchBarNav'
import SearchLogic from './searchbars/SearchLogic'
import { useAuth0 } from "@auth0/auth0-react";
import { AppContext } from '../AppContext';

function MyNavbar() {
	const location = useLocation();
	const { user, logout } = useAuth0();
	const { resultsViewMode } = useContext(AppContext);
	
	// Select logo based on environment variable, main -> live, stage -> test, else default
	let selectedLogo = logo;
	if (process.env.REACT_APP_BRANCH_NAME === "main") {
		selectedLogo = logo_live;
	} else if (process.env.REACT_APP_BRANCH_NAME === "stage") {
		selectedLogo = logo_test;
	} else if (process.env.REACT_APP_BRANCH_NAME === "dev") {
		selectedLogo = logo_bao;
	}
	return(
		<Navbar>

		<Link to="/" aria-label="Home">
			<img src={selectedLogo} alt="" className='w-72'></img>
		</Link>

		<NavbarSpacer />

		{/* Only show search bar on non-home pages and when not in consolidated or new view */}
		{ location.pathname !== '/' && resultsViewMode !== 'consolidated' && resultsViewMode !== 'new' &&
			<SearchLogic>
			{props => <SearchBarNav {...props} />}
			</SearchLogic>
		}

		<NavbarSpacer />

		<NavbarDivider />
		<NavbarItem aria-label="Support" href="/support">Support</NavbarItem>
		<NavbarDivider />
		<Dropdown>
			<DropdownButton as={NavbarItem} aria-label="Account menu">
			<Avatar src={user ? user.picture : ""} square />
			</DropdownButton>
			<DropdownMenu className="min-w-64" anchor="bottom end">
			{/* <DropdownItem href="/my-profile">
				<UserIcon />
				<DropdownLabel>My profile</DropdownLabel>
			</DropdownItem>
			<DropdownItem href="/settings">
				<Cog8ToothIcon />
				<DropdownLabel>Settings</DropdownLabel>
			</DropdownItem>
			<DropdownDivider />
			<DropdownItem href="/privacy-policy">
				<ShieldCheckIcon />
				<DropdownLabel>Privacy policy</DropdownLabel>
			</DropdownItem>
			<DropdownItem href="/share-feedback">
				<LightBulbIcon />
				<DropdownLabel>Share feedback</DropdownLabel>
			</DropdownItem>
			<DropdownDivider /> */}
			<DropdownItem onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
				<ArrowRightStartOnRectangleIcon />
				<DropdownLabel>Sign out</DropdownLabel>
			</DropdownItem>
			</DropdownMenu>
		</Dropdown>
		
		</Navbar>
	)
};

export default MyNavbar;
